import api from '../../services/api';

const getAuthHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const fetchDashboardStats = async (token) => {
  const res = await api.get('/api/admin/stats', getAuthHeaders(token));
  return res.data;
};

export const fetchLinkedAccounts = async (token) => {
  const res = await api.get('/api/admin/accounts', getAuthHeaders(token));
  return res.data.accounts;
};

export const fetchConsentLogs = async (token) => {
  const res = await api.get('/api/admin/logs', getAuthHeaders(token));
  return res.data;
};

export const fetchCACHistory = async (token) => {
  const res = await api.get('/api/admin/cac', getAuthHeaders(token));
  return res.data;
};


export const fetchPlatformStats = async () => {
  const token = localStorage.getItem('afrilink_token');
  const res = await api.get('/api/platform/stats', {
    headers: { Authorization: 'Bearer ' + token },
  });
  return res.data.data;
};




export const fetchSuggestions = async (secretKey) => {
  const res = await fetch(
    (window.location.hostname === 'localhost' ? 'http://localhost:4000' : 'https://api.afrilink.io') + '/api/suggestions',
    { headers: { 'x-api-key': secretKey } }
  );
  if (!res.ok) return [];
  const data = await res.json();
  return data.data || [];
};

export const fetchGoLiveStatus = async (appId) => {
  const token = localStorage.getItem('afrilink_token');
  const res = await fetch(
    (window.location.hostname === 'localhost' ? 'http://localhost:4000' : 'https://api.afrilink.io') + '/api/apps/' + appId + '/go-live',
    { headers: { Authorization: 'Bearer ' + token } }
  );
  if (!res.ok) return null;
  const data = await res.json();
  return data.data;
};

export const submitGoLive = async (appId, details) => {
  const token = localStorage.getItem('afrilink_token');
  const res = await fetch(
    (window.location.hostname === 'localhost' ? 'http://localhost:4000' : 'https://api.afrilink.io') + '/api/apps/' + appId + '/go-live',
    {
      method: 'POST',
      headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify(details),
    }
  );
  return res.json();
};
